/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ConnectionLink } from "./ConnectionLink";
export const CreateConnectionLinkResponse = core.serialization.object({
    data: ConnectionLink,
});
